
import "bootstrap/dist/css/bootstrap.min.css"
import "./index.scss"

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import PlacementsContainer from 'Placements/Placements.container'
import ErrorBoundary from "Placements/Components/ErrorBoundary"
import LIST_PAGES_CONFIG from "Placements/Configs/Pages.config"

import './Utils/i18n'

const { buildDate } = build.info
console.log(`Build Info | date -> ${buildDate}`)

ReactDOM.render(
  <Suspense fallback={(< div > Loading...</div >)}>
    <ErrorBoundary>
      <React.StrictMode>
        <PlacementsContainer configs={LIST_PAGES_CONFIG} />
      </React.StrictMode>
    </ErrorBoundary>
  </Suspense >,
  document.getElementById('gui')
)